@if(isVisible) {
  <div class="container w-full z-99999">
    <div class="banner w-full mt-20">
      <!-- <p class="message">🎉 Black Friday Specials! Don’t miss out on exclusive deals!</p>
      <button onclick="onViewMore()" class="view-more">View More</button>
      <button onclick="closeBanner()" class="close">✖</button> -->
      <div class="w-full h-screen dark:bg-gray-800">
        
        <section class="w-full mx-auto rounded-xl" >
          <div  class="rounded-2xl p-4  dark:bg-gray-700 mx-auto flex flex-col gap-y-5  border border-primary-500 shadow-xl  bg-cover  " [ngClass]="{'bg-red-800': view.site?.id === 146, 'bg-white': view.site?.id === 63 }" >
            <div class="flex justify-end">
              <button (click)="closeBanner()" class="close text-gray-800  flex justify- right-0">✖</button>
            </div>
            <!-- XL TRAVEL -->
            <a  *ngIf="view.site?.id === 146" class="flex flex-col justify-between h-full" href="https://xltravelgroup.ac-page.com/xl-travel-black-friday-2024" target="_blank">
                <h3  *ngIf="view.site?.id === 146"  class="text-xl md:text-4xl lg:text-7xl w-full mx-auto font-bold text-black dark:text-white text-center "> 🎉XL Travel Black Friday 2024 is LIVE</h3>
                <div *ngIf="view.site?.id === 146"  class="m-auto flex justify-center items-center lg:max-w-xl ">
                  <img [src]="view.currentImage" alt="Image" class="h-full w-full " />
                </div>
                <!-- <p *ngIf="view.site?.id === 146"  class="text-base md:text-lg lg:text-xl text-center text-gray-800 dark:text-gray-300 max-w-{400px}">Unlock unforgettable adventures with our exclusive Black Friday holiday packages...</p> -->
            <!-- XL TRAVEL -->
               <div class="flex justify-center items-center" *ngIf="view.site?.id === 146">
                <!-- <h3 class="font-semibold text-white">Click here to see XcLent, XcLusive deals!</h3> -->
                  <a class="bg-accent md:m-4 lg:m-6 dark:bg-primary hover:shadow-xl border border-transparent hover:drop-shadow text-white text-right font-semibold text-md lg:text-base rounded px-4 py-2 mt-10" 
                    href="https://xltravelgroup.ac-page.com/xl-travel-black-friday-2024" target="_blank">  Click here to see XcLent, XcLusive deals!</a>             
              </div>
            </a>
            <!-- SIMPLY NEXUS -->
            <a  *ngIf="view.site?.id === 63" [routerLink]="['/packages/black-friday-specials']" class="flex flex-col justify-between h-full" >
                <h3  *ngIf="view.site?.id === 63"  class="text-3xl md:text-4xl lg:text-5xl max-w-xl lg:max-w-3xl mx-auto font-bold text-black dark:text-white text-center "> 🎉 Black Friday Specials! Don’t miss out on exclusive deals!</h3>
                <!-- <div *ngIf="view.site?.id === 146"  class="m-auto flex justify-center items-center lg:max-w-xl ">
                  <img [src]="view.currentImage" alt="Image" class="h-full w-full " />
                </div> -->
                <p *ngIf="view.site?.id === 63"  class="text-base md:text-lg lg:text-xl text-center text-gray-800 dark:text-gray-300">Unlock unforgettable adventures with our exclusive Black Friday holiday packages</p>
                <!-- SIMPLY NEXUS -->
                  <div class="flex justify-center items-center"  *ngIf="view.site?.id === 63" >
                    <a  class="bg-primary dark:bg-primary w-1/2 md:w-1/3 hover:shadow-xl border border-transparent hover:drop-shadow transition duration-200 lg:w-1/3 text-white text-center font-semibold text-sm lg:text-base rounded px-4 py-2 mt-10" 
                      [routerLink]="['/packages/black-friday-specials']">  Black Friday Specials</a>             
                </div>
            </a>
          </div>
        </section>
      </div>
    </div>
  </div>
}



<!-- 
<div class="banner-container" *ngIf="isVisible">

  <div class="banner">
    <div class="shoe">
      <img src="../../../../../../assets/images/ecommerce/BF-Sale-Sticker.png" alt="">
    </div>
    <div class="content">
      <span>up to</span>
      <h3>50% 0ff</h3>
      <p>offer ends after 5 days</p>
      <button class="btn" (click)="onViewMore()">view offer</button>
    </div>
    <div class="women">
      <img src="../../../../../../assets/images/ecommerce/women.png" alt="">
    </div>
    <button class="close-btn" (click)="closeBanner()">✖</button>

  </div>

</div> -->